<template>


  <div :style="getStyle" v-loading="loading">
    <div style="padding: 10px 10px 0 10px">
      <el-form label-width="auto" inline>
        <el-form-item label="任务名称">
          <el-input v-model="keyword" style="width: 200px">
            <template #append>
              <el-button icon="Search" @click="preview"/>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="缩放单位">
          <el-select v-model="ele.setting.initialScale" style="width: 100px" @change="preview">
            <el-option label="小时" value="hour"></el-option>
            <el-option label="天" value="day"></el-option>
            <el-option label="周" value="week"></el-option>
            <el-option label="月" value="month"></el-option>
            <el-option label="季度" value="quarter"></el-option>
            <el-option label="年" value="year"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div :id="element.id" :style="{width: '100%',height: `${element.h * ratio.height-65}px`}"></div>

    </div>
  </div>


</template>

<script>
//防止vue代理chart实例被代理
import gantt from 'dhtmlx-gantt'
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css'
import chartFactory from "@/components/design-report/chartFactory";

export default {
  props: {
    element: {
      type: Object,
      default: () => {
        return {}
      }
    },
    elements: {
      type: Array,
      default: () => []
    },
    report:{
      type:Object,
      default: () => {}
    },
    ratio: {
      type: Object,
      default: () => {
        return {
          width: 1,
          height: 1
        }
      }
    },
    mode: {
      type: String,
      default: 'edit'
    },
    diving: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "element.w": {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.resize();
        });
      },
      immediate: false
    },
    "element.h": {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.resize();
        });
      },
      immediate: false
    },
    "element.originalData": {
      handler(newValue, oldValue) {
        this.preview()
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    getStyle() {

      if (this.mode === 'edit') {
        return {
          width: `${this.element.w * this.ratio.width}px`,
          height: `${this.element.h * this.ratio.height}px`
        }
      } else {
        return {
          position: this.diving ? 'none' : 'absolute',
          'box-sizing': 'border-box',
          width: `${this.element.w * this.ratio.width}px`,
          height: `${this.element.h * this.ratio.height}px`,
          transform: this.diving ? 'none' : `translate(${this.element.x * this.ratio.width}px, ${this.element.y * this.ratio.height}px)`,
          'z-index': this.element.index,
        }
      }


    }
  },
  data() {
    return {
      ele: null,
      chart: null,
      isPreviewing: false,
      keyword: '',
      expand: false,
      loading:false,
      taskClickId: null,
    }
  },
  created() {
    this.ele = this.element
  },
  mounted() {
    this.preview()
  },
  methods: {
    preview() {

      if (this.isPreviewing) return; // 防止递归
      this.isPreviewing = true;

      let chartDom = document.getElementById(this.element.id);

      if (chartDom) {


        gantt.config.date_format = "%Y-%m-%d %H:%i";
        gantt.config.autosize = "y";
        gantt.config.scroll_size = 15;

        // 更简单的周计算方式
        const weekScaleTemplate = (date) => {
          const month = date.getMonth() + 1;
          const day = date.getDate();

          // 简单按每4天为一周计算(适用于可视化展示)
          const weekNumber = Math.ceil(day / 7);

          return `第${weekNumber}周`;
        };

        // 设置初始缩放级别·
        if (this.element.setting && this.element.setting.initialScale) {
          switch (this.element.setting.initialScale) {
            case 'hour':
              gantt.config.scale_unit = "hour";
              gantt.config.date_scale = "%H时";
              gantt.config.subscales = [
                {unit: "day", step: 1, date: "%M%d日"}
              ];
              break;
            case 'week':
              gantt.config.scale_unit = "month";
              gantt.config.step = 1;
              gantt.config.date_scale = "%Y年%m月";
              gantt.config.subscales = [
                {unit: "week", step: 1, format: weekScaleTemplate}
              ];
              break;
            case 'month':
              gantt.config.scale_unit = "month";
              gantt.config.date_scale = "%m月";
              gantt.config.subscales = [
                {unit: "year", step: 1, date: "%Y"}
              ];
              break;
            case 'quarter':
              gantt.config.scale_unit = "month";
              gantt.config.date_scale = "%m月";
              gantt.config.subscales = [
                {
                  unit: "quarter",
                  step: 1,
                  date: function (date) {
                    const year = date.getFullYear();
                    const month = date.getMonth();
                    const quarter = Math.floor(month / 3) + 1;
                    return `${year}年第${quarter}季度`;
                  }
                }
              ];
              break;
            case 'year':
              gantt.config.scale_unit = "year";
              gantt.config.date_scale = "%Y年";
              gantt.config.subscales = [
                {unit: "year", step: 5, date: "%Y"}
              ];
              break;
            default:
              gantt.config.scale_unit = "month";
              gantt.config.step = 1;
              gantt.config.date_scale = "%F, %Y";

              gantt.config.subscales = [
                {
                  unit: "day",
                  step: 1,
                  date: "%d"
                }
              ];
              break;
          }
        }


        gantt.config.readonly = true;
        gantt.config.grid_width = 580;
        gantt.config.columns = [
          {name: "text", label: "任务名称", tree: true, width: '*'},
          {name: "start_date", label: "开始时间", align: "center", width: '100'},
          {name: "end_date", label: "结束时间", align: "center", width: '100'},
          {name: "status", label: "状态", align: "center", width: '100'},
        ];
        gantt.locale = {
          date: {
            month_full: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
            month_short: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
            day_full: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
            day_short: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
          },
          labels: {
            quarters: ["Q1", "Q2", "Q3", "Q4"],  // 添加季度标识
            quarter: "季度"
          }
        };

        gantt.config.autosize = false;
        gantt.init(this.element.id);

        // 先解绑旧事件，防止重复绑定
        if (this.taskClickId) {
          gantt.detachEvent(this.taskClickId);
        }

        // 添加行点击事件监听
        this.taskClickId = gantt.attachEvent("onTaskClick", (id, e) => {
          const task = gantt.getTask(id);
          this.handleClick(task);
          return true;
        });

        if (this.element.originalData) {
          this.filterDate(this.element)
        }

        gantt.clearAll();
        gantt.parse(this.deepClone({data: this.element.option.data, links: this.element.option.links}));
      }

      this.$nextTick(() => {
        this.isPreviewing = false; // 重置标志位
      });
    },
    resize() {

    },
    handleClick(task) {

      this.elements.filter(filter=>filter.dataset.quickLook.includes(this.element.id)).forEach(item=>{
        //重置其它筛选框
        if(item.type.indexOf('Filter')!==-1){
          item.option.value = item.option.multiple?[]:''
        }
        if(item.dataset.divingConditions){
          delete item.dataset.divingConditions
        }

        let ele = this.element;
        ele.toConditions = ()=>{
          return {
            fieldName: task.parent? this.element.setting.quickLook.alias['二级标题']:this.element.setting.quickLook.alias['一级标题'],
            cs:   'EQUALS',
            value: task.text,
          }
        };

        chartFactory.preview(this.report.id, item, this.elements, () => {
        });
      })

    },
    filterDate(element) {

      let resultData = []
      let resultLink = []
      let filterData = element.originalData.filter(filter => {
        return filter[element.setting.name].indexOf(this.keyword) !== -1;
      })

      if (filterData.length === 1) {
        this.expand = true;
      }

      for (let i = 0; i < filterData.length; i++) {

        let dataItem = filterData[i]


        let main = {
          id: i + 1,
          text: dataItem[element.setting.name],
          start_date: dataItem[element.setting.start],
          end_date: dataItem[element.setting.end] + " 12:00",
          status: dataItem[element.setting.status],
          duration: dataItem[element.setting.duration],
          progress: 0,
          open: this.expand
        }

        if (!dataItem[element.setting.end]) {
          delete main.end
        } else if (dataItem[element.setting.duration]) {
          delete main.duration
        }

        resultData.push(main)
        let lastChild = null;

        for (let j = 0; j < element.setting.children.length; j++) {
          let item = element.setting.children[j]
          let child = {
            id: (i + 1) + "." + (j + 1),
            text: item.name,
            start_date: dataItem[item.start],
            end_date: dataItem[item.end] + " 12:00",
            duration: dataItem[item.duration],
            status: dataItem[item.status],
            parent: main.id,
            progress: 0,
          }

          if (!dataItem[item.end]) {
            delete child.end_date
          } else if (dataItem[item.duration]) {
            delete child.duration
          }

          resultData.push(child)
          if (lastChild === null) {
            resultLink.push({id: resultLink.length + 1, source: main.id, target: child.id, type: "0"})
          } else {
            resultLink.push({id: resultLink.length + 1, source: lastChild.id, target: child.id, type: "0"})
          }

          lastChild = child;
        }
      }

      element.option.data = resultData;
      element.option.links = resultLink;
    }
  }


}

</script>

<style scoped lang="scss">
.gantt-container {
  width: 100%;
  height: v-bind("`300px`");
  overflow-y: auto;
  overflow-x: hidden;
}
</style>